import { useAppTranslation } from '../i18n/useAppTranslation';
import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Paper, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SportsScore, Person, AdminPanelSettings } from '@mui/icons-material';

const AdminRoleSwitcher = () => {
  const { tr } = useAppTranslation();
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    if (user?.role !== 'ADMIN') return null;

    const currentView = location.pathname.includes('/coach') ? 'COACH' :
        location.pathname.includes('/sportif') ? 'SPORTIF' : '';

    const handleAlignment = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (newAlignment === 'COACH') {
            navigate('/coach/dashboard');
        } else if (newAlignment === 'SPORTIF') {
            navigate('/sportif/dashboard');
        }
    };

    if (!currentView) return null; // Don't show on non-dashboard pages like /messages or home if preferred

    return (
        <Box sx={{ position: 'fixed', bottom: 20, right: 20, zIndex: 9999 }}>
            <Paper elevation={3} sx={{ p: 1, borderRadius: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1 }}>
                    <AdminPanelSettings fontSize="small" color="primary" />
                    <Typography variant="caption" fontWeight="bold" color="primary">{tr("Admin Mode")}</Typography>
                </Box>
                <ToggleButtonGroup
                    value={currentView}
                    exclusive
                    onChange={handleAlignment}
                    size="small"
                    aria-label="admin role switch"
                    orientation="vertical"
                >
                    <ToggleButton value="COACH" aria-label="coach view" sx={{ borderRadius: 2 }}>
                        <SportsScore sx={{ mr: 1, fontSize: 18 }} />
                         {tr("Coach")} </ToggleButton>
                    <ToggleButton value="SPORTIF" aria-label="sportif view" sx={{ borderRadius: 2 }}>
                        <Person sx={{ mr: 1, fontSize: 18 }} />
                         {tr("Sportif")} </ToggleButton>
                </ToggleButtonGroup>
            </Paper>
        </Box>
    );
};

export default AdminRoleSwitcher;
